import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

type Filter = {
  field: string;
  values: string[];
  valueType: number;
  operationType: number;
};

type GetMerchantBalanceRequest = {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
  status: string;
  filters: Filter[];
};

type MerchantBalance = {
  merchantId: number | null;
  merchantName: string | null;
  currency: string;
  currencyCode: string;
  debt: number;
  credit: number;
  debtBalance: number;
  creditBalance: number;
};

type PaginatedResponse = {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  orderBy: string;
  orderByDesc: boolean;
  result: MerchantBalance[];
};

async function getMerchantCurrentBalances(
  data: GetMerchantBalanceRequest
): Promise<BaseResponse<PaginatedResponse>> {
  try {
    const response = await axiosInstance.post("/Merchant/GetMerchantCurrentBalances", data);
    return response.data;
  } catch (ex) {
    if (ex instanceof AxiosError && ex.response?.data) {
      throw ex.response.data.error;
    }
    throw ex;
  }
}

export function useGetMerchantCurrentBalances() {
  return useMutation<BaseResponse<PaginatedResponse>, Error, GetMerchantBalanceRequest>(
    getMerchantCurrentBalances
  );
}